// 검사 vuex
const vocStore = {
  namespaced: true,

  state: {
    voc: {
      list: [],
      page: 0,
      dates: [],
      isMyCustomer: true,
      clientID: '-1',
      scrollTo: 0,
      SearchTitle: ''
    },
    vocDetail: {
      vid: ''
    }
  },

  getters: {
    getVoc: state => state.voc,
    getVid: state => state.vocDetail.vid
  },

  mutations: {
    mutationVoc: (state, payload) => {
      state.voc = payload
    },

    mutationVid: (state, payload) => {
      state.vocDetail.vid = payload
    },

    resetVoc: (state) => {
      state.voc = {
        list: [],
        page: 0,
        dates: [],
        isMyCustomer: true,
        clientID: '-1',
        scrollTo: 0,
        SearchTitle: ''
      }
    }
  }
}

export default vocStore
